<template>

  <div id="dialog-boardEdit">
    <div class="write-board">

      <div class="header">
        <p @click="windowOnOff(false)"><i class="ph-bold ph-arrow-left"></i></p>
        <h2>글쓰기</h2>
        <p><i class="ph-bold ph-dots-three"></i></p>
      </div>

      <div id="module-editor">
        <div class="header">
          <img v-if="thumbnailImg" :src="thumbnailImg" alt="Thumbnail" class="thumb" />
          <div class="cover">
            <div class="board-shell">
              <select name="type" id="type" v-model="selectedBoard">
                <option v-for="board in board_list" :key="board.idx" :value="board.idx">{{ board.name }}</option>
              </select>
            </div>
            <div class="index">
              <input type="text" name="title" id="title" maxlength="20" placeholder="제목을 입력하세요..." v-model="title" />
              <ul>
                <!--
                <li><i class="ph ph-bell"></i> </li>
                <li><i class="ph ph-bell"></i> </li>
                -->
                <li>
                  <label for="file" style="cursor:pointer;"> <i class="ph ph-image"></i> </label>
                  <input style="display: none;" type="file" id="file" name="file" accept="image/*" @change="onFileChange" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="content">
          <div id="editorjs"></div>
        </div>

        <p id="saveBtn" @click="saveContent">저장</p>
      </div>

    </div>
  </div>

</template>


<script>
import { inject, ref, onMounted } from "vue"

import EditorJS from '@editorjs/editorjs'
import Header from '@editorjs/header'
import ImageTool from '@editorjs/image'
import List from '@editorjs/list'
import Attaches from '@editorjs/attaches'


export default {
  emits: ['submit'],
  props: {
    thePost: Object,
    windowOnOff: Function,
    reloadPost: Function,
  },
  setup(props) {
    const sql_query = inject('sql_query');
    const getMbid = inject('getMbid');
    const member_info = inject('member_info');
    const selectedBoard = ref(10);
    const updatePost = inject('updatePost');

    const table = "board_reference";
    let on_idx = null; // 글 고유값

    const savedData = ref(null); // 데이터를 저장할 ref
    const editor = ref(null);
    const title = ref('');
    
    const thumbnailImg = ref(''); // 기본 이미지 URL
    const savedThumb = ref(''); // 저장된 썸네일 이미지 URL
    const userFiles = ref([]); // 업로드된 파일 목록

    const board_list = ref([]);


    if (props.thePost) {
      on_idx = Number(props.thePost.idx);
    }

    // 새글 처리
    // if (on_idx === null) {
    //   sql_query(`SELECT * FROM ${table} WHERE mb_id = '${getMbid()}' and is_temp = '1' `).then((exist) => {
    //     if (exist.length > 0) {
    //       let ask = confirm("임시 저장된 글이 있습니다. 불러오시겠습니까?");
    //       if (ask) {
    //         on_idx = exist[0].idx;
    //         LoadPost(on_idx);
    //         settingEDJS();
    //         console.log("임시 저장된 글 ID", on_idx);
    //       } else {
    //         sql_query(`DELETE FROM ${table} WHERE mb_id = '${getMbid()}' and idx = '${exist[0].idx}' `);
    //         makePost(null, "제목없는 글", table)
    //           .then((res) => {on_idx = res.insertId; console.log(`이제 니 아이디는 ${res.insertId}`);})
    //           .catch((err) => { console.error("글 생성 실패", err); });
    //       }
    //     } else {
    //       makePost(null, "제목없는 글", table)
    //         .then((res) => {on_idx = res.insertId; console.log(`이제 니 아이디는 ${res.insertId}`);})
    //         .catch((err) => { console.error("글 생성 실패", err); });
    //     }
    //   });
    // }
    if (on_idx === null) {
      sql_query(`SELECT * FROM ${table} WHERE mb_id = '${getMbid()}' and is_temp = '1' `).then((exist) => {
        if (exist.length > 0) {
          sql_query(`DELETE FROM ${table} WHERE mb_id = '${getMbid()}' and idx = '${exist[0].idx}' `);
          makePost(null, "제목없는 글", table)
            .then((res) => {on_idx = res.insertId; console.log(`이제 니 아이디는 ${res.insertId}`);})
            .catch((err) => { console.error("글 생성 실패", err); });
        } else {
          makePost(null, "제목없는 글", table)
            .then((res) => {on_idx = res.insertId; console.log(`이제 니 아이디는 ${res.insertId}`);})
            .catch((err) => { console.error("글 생성 실패", err); });
        }
      });
    }


    async function makePost(idx, title, table) {
      let res = await sql_query(`INSERT INTO ${table} (idx, title, content, thumb, mb_id, is_temp) VALUES (${idx}, '${title}', '', '', '${getMbid()}', '1')`);
      return res;
    }

    async function LoadPost(idx) {
      let res = await sql_query(`SELECT * FROM board_reference WHERE idx = ${idx}`);
      return res;
    }

    async function fetchBoards() {
      let sql = `SELECT * FROM board_category where status = '1' and view_only = '1' and write_only = '1' ORDER BY sort_order ASC`;
      if (member_info.level <= 1) {
        sql = `SELECT * FROM board_category ORDER BY sort_order ASC`;
      }
      const response = await sql_query(sql);
      board_list.value = response;
    }

    async function saveContent() {
      if (editor.value) {
        try {
          const outputData = await editor.value.save();
          console.log('[SAVE]', JSON.stringify(outputData, null, 2));

          // 썸네일 처리: 새로 업로드한 것이 없으면 기존 썸네일 유지
          const isBlobUrl = (u) => u && u.startsWith('blob:');
          const thumbToSave = savedThumb.value || (!isBlobUrl(thumbnailImg.value) ? thumbnailImg.value : '');

          updatePost(on_idx, title.value, table, outputData, thumbToSave, selectedBoard.value)
            .then(() => { props.reloadPost() })
            .catch(console.error);
          props.windowOnOff(false);
        } catch (error) {
          console.error('저장 중 오류 발생:', error);
        }
      }
    }

    // 썸네일 업로드
    const onFileChange = async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      /* 1) 로컬 미리보기 */
      const localUrl = URL.createObjectURL(file);
      thumbnailImg.value = localUrl; // ← 헤더에 즉시 표시

      const formData = new FormData();
      formData.append('idx', on_idx); // 글 고유값 추가
      formData.append('table', table); // 테이블 이름 추가
      formData.append('usage', 'post_img');
      formData.append('user', getMbid());
      formData.append('file', file);

      const response = await fetch('api/upload/image', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      console.log("업로드된 파일:", data);
      savedThumb.value = data.url; // 서버에서 반환된 이미지 URL
      console.log("업로드된 파일 URL:", savedThumb.value);

    };

    async function settingEDJS() {
      if (props.thePost) {
        try {
          const response = (await LoadPost(props.thePost.idx))[0];
          savedData.value = response.content ? JSON.parse(response.content) : {};
          thumbnailImg.value = response.thumb;
          title.value = response.title;
        } catch (error) {
          console.error("게시물 조회 실패:", error);
        }
      }
      
      await initEditor();
    }

    onMounted(async () => {
      settingEDJS();
      await fetchBoards();
    });

    const initEditor = async () => {
      if (editor.value) {
        editor.value.destroy();
      }
      editor.value = new EditorJS({
        holder: 'editorjs',
        placeholder: '여기에 글을 작성하세요...',
        autofocus: true,
        inlineToolbar: true,
        data: savedData.value || {},
        tools: {
          header: Header,
          list: List,
          attaches: {
            class: Attaches,
            config: {
              uploader: {
                async uploadByFile(file) {
                  const formData = new FormData();
                  formData.append('idx', on_idx);
                  formData.append('table', table);
                  formData.append('usage', 'post_file');
                  formData.append('user', getMbid());
                  formData.append('file', file);

                  const response = await fetch('/upload/document', {
                    method: 'POST',
                    body: formData,
                  });
                  const data = await response.json();

                  return {
                    success: 1,
                    file: {
                      url: data.url,
                      name: file.name,
                      size: file.size,
                    }
                  };
                },
              },
            },
          },
          image: {
            class: ImageTool,
            config: {
              uploader: {
                async uploadByFile(file) {
                  const formData = new FormData();
                  formData.append('idx', on_idx);
                  formData.append('table', table);
                  formData.append('usage', 'post_img');
                  formData.append('user', getMbid());
                  formData.append('file', file);

                  const response = await fetch('api/upload/image', {
                    method: 'POST',
                    body: formData,
                  });

                  const data = await response.json();
                  return {
                    success: 1,
                    file: {
                      url: data.url,
                      name: file.name,
                      size: file.size,
                    }
                  };
                },
              },
            },
          },
        },
        onReady: () => {
          console.log('Editor.js 초기화 완료');
        },
        onChange: async () => {
          // 변화 감지 시 로직 (사용 중인 이미지 필터링 등)
        },
        i18n: {
            /**
             * @type {I18nDictionary}
             */
            messages: {
              ui: {
                "blockTunes": { "toggler": { "Click to tune": "클릭하여 조정", "or drag to move": "또는 드래그하여 이동" }, },
                "inlineToolbar": { "converter": { "Convert to": "변환하기" } },
                "toolbar": { "toolbox": { "Add": "추가" } }
              },
              toolNames: {
                "Text": "문단",
                "Heading": "제목",
                "List": "목록",
                "Warning": "경고",
                "Checklist": "체크리스트",
                "Attachment": "첨부 파일",
                "Unordered List": "점 목록",
                "Ordered List": "숫자 목록",
                "Quote": "인용",
                "Code": "코드",
                "Image": "사진",
                "Delimiter": "구분 기호",
                "Raw HTML": "HTML코드",
                "Table": "표",
                "Link": "링크",
                "Marker": "마커",
                "Bold": "굵게",
                "Italic": "이탤릭",
                "InlineCode": "인라인 코드",
              },
              tools: {
                "warning": { "Title": "제목", "Message": "메시지", },
                "link": { "Add a link": "링크를 추가" },
                "stub": { 'The block can not be displayed correctly.': '블록을 올바르게 표시할 수 없습니다.' }
              },
              blockTunes: {
                "delete": { "Delete": "삭제" },
                "moveUp": { "Move up": "위로" },
                "moveDown": { "Move down": "아래로" }
              },
            }
          },
      });
    };

    return {
      sql_query,
      getMbid,
      selectedBoard,
      savedData,
      editor,
      title,
      thumbnailImg,
      savedThumb,
      userFiles,
      board_list,
      saveContent,
      onFileChange
    }
  }
}
</script>


<style scoped>
#dialog-boardEdit {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: var(--color-background);
  z-index: 999;
}


.write-board {
  width: 100%;
  height: 100%;
  overflow: hidden;
  width:100%;
  height: fit-content;
  display:flex;
  flex-direction: column;
  align-items: center;
}

.write-board > .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  color: var(--color-text-primary);
  padding: 16px;
  box-sizing: border-box;
}

.write-board > .header > p {
  aspect-ratio: 1/1;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--color-text-primary);
  font-size: var(--font-size-xl);
  cursor: pointer;
  margin:0;
  padding:0;
}

.write-board > .header > h2 {
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
  margin:0;
  padding:0;
}


#module-editor {
  position: relative;
  width: 100%;
  /* max-width: var(--break-point-mobile); */
  display:flex;
  flex-direction: column;
  margin: 0 auto;
  gap:48px;
  overflow: scroll;
}

@media (max-width: 768px) {
  #module-editor {
    max-width: 600px;
    padding:16px;
    box-sizing: border-box;
  }
}

#module-editor .header {
  display: flex;
  flex-direction: column;
  justify-content: end;
  border-bottom: 1px solid var(--color-text-secondary);
  min-height: 400px;
  height: 400px;
  background: var(--color-text-secondary);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;
}

#module-editor .header > .thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

#module-editor .header > .cover {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  height: 100%;
  background: rgba(0,0,0,0.6);
  padding: 12px;
  box-sizing: border-box;
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
}

#module-editor .header > .cover > .board-shell {
  width: 100%;
  max-width: var(--break-point-mobile);
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 12px;
}

#module-editor .header > .cover > .board-shell > select {
  width: 200px;
  background: var(--color-background-light);
  border: none;
  margin:0;
  font-size:var( --font-size-md);
  max-width: var(--break-point-mobile);
  color: #fff;
  padding:6px;
  border-radius: 12px;
}

#module-editor .header > .cover > .board-shell > select:focus {
  outline: none;
}

#module-editor .header > .cover > .index {
  display:flex;
  height:var(--font-size-5xl);
  width: 100%;
  max-width: var(--break-point-mobile);
}

#module-editor .header > .cover > .index > input {
  width: 100%;
  background: none;
  border: none;
  margin:0;
  font-size:var(--font-size-3xl);
  color:#fff;
  font-weight: 700;
  border-bottom: 2px solid var(--color-text-secondary);
  color:var(--color-text-white);
}

#module-editor .header > .cover > .index > input::placeholder {
  color: rgba(255,255,255,0.6);
  opacity:0.6;
}

#module-editor .header > .cover > .index > input:focus {
  outline: none;
}

#module-editor .header > .cover > .index > ul {
  display: flex;
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin:0;
  padding:0;
}

#module-editor .header > .cover > .index > ul > li {
  width:48px;
  height:48px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
}

#module-editor .header > .cover > .index > ul > li > label {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-xl);
  cursor: pointer;
  color:#fff;
}

#module-editor .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

#module-editor .content > #editorjs {
  width: 100%;
  height: 74vh;
  color:var(--color-text-primary) !important;
  max-width: var(--break-point-mobile);
}

#module-editor #saveBtn { 
  position: fixed;
  right: 24px;
  bottom: 24px;
  padding: 12px 24px;
  background: var(--color-brand);
  color:var(--color-text-black);
  margin:0;
  border-radius: 24px;
  cursor: pointer;
  z-index: 99;
}
</style>



<style>
.ce-popover-item {
  transition: all 0.2s ease-out;
}
.ce-popover-item:hover {
  padding-left:12px;
}

.ce-toolbar__actions,
.ce-toolbar__actions * {
  font-size: 14px;
  color: var(--color-text-primary) !important;
  background: var(--color-primary) !important;
  border: none;
}

.ce-popover__container {
  border: solid 1px var(--color-text-secondary);
  background: var(--color-primary) !important;
}

.ce-block__content {
  max-width: 100% !important;
}
.ce-toolbar__content {
  max-width: 100% !important;
  color:var(--color-text-primary) !important;
}
</style>